module.exports = __webpack_public_path__ + "static/dance-1-ce5d3deab910a5c183e1ca35ec9a076e.gif";